import { createRouter, createWebHistory, RouteLocation, RouteRecordRaw } from 'vue-router'
import { isLoggedIn } from '@/services/infrastructure/auth.service'
import { rememberTenantId } from '@/tenants/org.service'
import { bootstrapService } from '@/services/infrastructure/bootstrap.service'

const LOGIN: RouteRecordRaw = { name: 'login', path: '/login', component: () => import('@/views/LoginView.vue') }

const TENANT_SPECIFIER: RouteRecordRaw = {
    path: '/organization/:tenantId/:panelContent?',
    component: () => { },
    meta: { requiresLogin: true },
    beforeEnter: async (to) => {
        rememberTenantId(to.params.tenantId as string)
        return {
            path: '/' + to.params.panelContent || '',
            params: {
                panelContent: to.params.panelContent,
            }
        }
    }
}

const PANEL_MANAGER: RouteRecordRaw = {
    name: 'panelManager',
    path: '/:panelContent?',
    component: () => import('@/views/MultiPanelLayout.vue'),
    meta: { requiresLogin: true }
}

const routes = [LOGIN, TENANT_SPECIFIER, PANEL_MANAGER]

const router = createRouter({
    history: createWebHistory(),
    routes
})

const safeRedirect = (previousTarget: RouteLocation, newTarget: RouteRecordRaw) => {
    if (previousTarget.path === newTarget.path)
        return true
    return newTarget
}


router.beforeEach(async to => {
    if (to.meta.requiresLogin) {
        // Wait for bootstrap to complete (auth + org loading)
        await bootstrapService.initializationPromise
        if (!isLoggedIn.value)
            return safeRedirect(to, LOGIN)
    }
    return true
})

export { router }

export {
    LOGIN, PANEL_MANAGER
}